"use client"

import { useState } from "react"
import "./css/contactos.css"

const ContactoServicios = () => {
  const [formData, setFormData] = useState({
    nombre: "",
    numero: "",
    correo: "",
    mensaje: "",
  })

  const [isSubmitting, setIsSubmitting] = useState(false)
  const [alert, setAlert] = useState({ show: false, type: '', message: '' })

  const showAlert = (type, message) => {
    setAlert({ show: true, type, message })
    setTimeout(() => {
      setAlert({ show: false, type: '', message: '' })
    }, 3000)
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData({
      ...formData,
      [name]: value,
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsSubmitting(true)

    try {
      // Preparar los datos según el formato esperado por el servidor
      const dataToSend = {
        name: formData.nombre,
        phone: formData.numero,
        mail: formData.correo,
        message: formData.mensaje,
      }

      const response = await fetch("https://www.yetiadvisers.com/send_contactamt", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataToSend),
      })

      if (response.ok) {
        // Resetear el formulario después de enviar exitosamente
        setFormData({
          nombre: "",
          numero: "",
          correo: "",
          mensaje: "",
        })
        showAlert('success', 'Mensaje enviado con éxito')
      } else {
        throw new Error("Error al enviar el mensaje")
      }
    } catch (error) {
      console.error("Error:", error)
      showAlert('error', 'Error al enviar el mensaje. Por favor, inténtalo de nuevo.')
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <section className="contacto-section" id="Contacto">
      {/* Alerta flotante */}
      {alert.show && (
        <div className={`floating-alert ${alert.type}`}>
          <div className="alert-content">
            <span className="alert-icon">
              {alert.type === 'success' ? '✓' : '✕'}
            </span>
            <span className="alert-message">{alert.message}</span>
          </div>
        </div>
      )}

      <div className="cauca-content">
        <div className="contact-info">
          <h2 className="contactanos-title">Contáctanos</h2>
          <div className="info-block">
            <h3>Ubicación</h3>
            <p>9a Avenida 15-84A Aurora 1 zona 13</p>
          </div>
          <div className="info-block">
            <h3>Ventas</h3>
            <p>Tel: 5697-6272</p>
          </div>
        </div>

        <div className="contact-form">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="nombre">Nombre</label>
              <input
                type="text"
                id="nombre"
                name="nombre"
                value={formData.nombre}
                onChange={handleChange}
                required
                disabled={isSubmitting}
              />
            </div>

            <div className="form-group">
              <label htmlFor="numero">Número</label>
              <input
                type="tel"
                id="numero"
                name="numero"
                value={formData.numero}
                onChange={handleChange}
                required
                disabled={isSubmitting}
              />
            </div>

            <div className="form-group">
              <label htmlFor="correo">Correo Electrónico</label>
              <input
                type="email"
                id="correo"
                name="correo"
                value={formData.correo}
                onChange={handleChange}
                required
                disabled={isSubmitting}
              />
            </div>

            <div className="form-group">
              <label htmlFor="mensaje">Mensaje</label>
              <textarea
                id="mensaje"
                name="mensaje"
                value={formData.mensaje}
                onChange={handleChange}
                rows="4"
                required
                disabled={isSubmitting}
              ></textarea>
            </div>

            <button type="submit" className="submit-button" disabled={isSubmitting}>
              {isSubmitting ? "ENVIANDO..." : "ENVIAR"}
            </button>
          </form>
        </div>
      </div>
    </section>
  )
}

export default ContactoServicios
